import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowDown as ArrowDownIcon } from "@air/next-icons";
import { VisuallyHidden } from "@air/primitive-visually-hidden";
import classNames from "classnames";
import { forwardRef, memo } from "react";
import { SORT_BUTTON, SORT_BUTTON_ARROW, SORT_BUTTON_TYPE } from "~/constants/testIDs";
const BUTTON_CLASS_NAMES = "group flex h-8 cursor-pointer items-center justify-start gap-1 border-0 bg-transparent py-0 text-12 font-semibold transition-all hover:underline";
export const _SortButton = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { children, className, direction, onClick, style, type, isActive } = param;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": SORT_BUTTON,
        "data-direction": direction,
        className: classNames("inline-flex", className),
        ref: forwardedRef,
        style: style,
        children: [
            /*#__PURE__*/ _jsxs("button", {
                className: classNames(BUTTON_CLASS_NAMES, direction ? "text-grey-11" : "text-grey-10", isActive && "underline"),
                "data-testid": "".concat(SORT_BUTTON_TYPE, "-").concat(type),
                "data-direction": direction,
                onClick: onClick,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "truncate",
                        children: children
                    }),
                    /*#__PURE__*/ _jsx(ArrowDownIcon, {
                        className: classNames("h-3 min-w-3 max-w-3 transition-all", {
                            "rotate-180": direction === "asc",
                            "rotate-0": direction === "desc",
                            "opacity-0": !isActive,
                            "opacity-100": isActive,
                            "group-hover:opacity-100": !isActive
                        }),
                        "data-testid": "".concat(SORT_BUTTON_ARROW, "-").concat(type, "-").concat(direction),
                        "data-direction": direction
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(VisuallyHidden, {
                children: direction === "desc" ? "Sort descending" : "Sort ascending"
            })
        ]
    });
});
_SortButton.displayName = "SortButton";
export const SortButton = /*#__PURE__*/ memo(_SortButton);
